import { Modal } from 'antd';
import styles from './index.module.scss';

interface NewFieldsModalProps {
	open: boolean;
	// Human-readable labels of the fields created during the import.
	fieldLabels: string[];
	// "Go to Configurations" — navigate to the Configurations drawer to map GL accounts.
	onGoToConfigurations: () => void;
	// "Later" — dismiss without navigating.
	onLater: () => void;
}

/**
 * ENG-374: post-import reminder shown by EmployeeCostsMain AFTER the Smart Import
 * wizard closes, when the import created new fields. Those fields land in
 * Configuration.settings with null Debit/Credit GL accounts, so the user must map
 * them before they post correctly to QuickBooks. Presentational only — all state and
 * navigation live in the parent.
 */
export default function NewFieldsModal({
	open,
	fieldLabels,
	onGoToConfigurations,
	onLater,
}: NewFieldsModalProps) {
	return (
		<Modal
			open={open}
			title="New Fields Require Configuration"
			okText="Go to Configurations"
			cancelText="Later"
			closable={false}
			maskClosable={false}
			onOk={onGoToConfigurations}
			onCancel={onLater}
		>
			<p>
				The following new field(s) were added during import and require GL account
				mapping in Configurations before they will post correctly to QuickBooks:
			</p>
			<ul className={styles['new-fields-modal__list']}>
				{fieldLabels.map((label, i) => (
					<li key={i}>{label}</li>
				))}
			</ul>
			<p>
				Please navigate to Settings → Configurations to assign Debit and Credit GL
				accounts for each field, then click Save &amp; Close.
			</p>
		</Modal>
	);
}
